export type ApiMode = 'mock' | 'backend';

export interface RuntimeEnvironment {
  readonly VITE_API_MODE?: string;
  readonly VITE_API_BASE_URL?: string;
}

export interface RuntimeConfig {
  readonly apiMode: ApiMode;
  readonly apiBaseUrl: string | null;
}

export function parseRuntimeConfig(environment: RuntimeEnvironment): RuntimeConfig {
  const apiMode = environment.VITE_API_MODE ?? 'mock';
  if (apiMode !== 'mock' && apiMode !== 'backend') {
    throw new Error('VITE_API_MODE must be either "mock" or "backend"');
  }

  if (apiMode === 'mock') {
    return Object.freeze({ apiMode, apiBaseUrl: null });
  }

  const rawBaseUrl = environment.VITE_API_BASE_URL?.trim();
  if (!rawBaseUrl) {
    throw new Error('VITE_API_BASE_URL is required in backend mode');
  }

  let parsed: URL;
  try {
    parsed = new URL(rawBaseUrl);
  } catch {
    throw new Error('VITE_API_BASE_URL must be an absolute HTTPS origin');
  }

  if (
    parsed.protocol !== 'https:' ||
    parsed.username ||
    parsed.password ||
    parsed.pathname !== '/' ||
    parsed.search ||
    parsed.hash
  ) {
    throw new Error('VITE_API_BASE_URL must be an absolute HTTPS origin');
  }

  return Object.freeze({ apiMode, apiBaseUrl: parsed.origin });
}

export const runtimeConfig = parseRuntimeConfig(import.meta.env);
